// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const FormatTextDefault = createSvgIcon(
  { All: <React.Fragment><g><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 9.5L13.5 8l-5 5-.5 2 2-.5 5-5z" /><path fill="currentColor" stroke="transparent" fillRule="evenodd" d="M6.481 0a1 1 0 01.935.6l1.75 4 .875 2 .19.434-1.509 1.51a1.007 1.007 0 01-.076-.143l-.437-1-.875-2L6.55 3.61 4.039 10h3.227l-2 2H3.253l-1.322 3.366a1 1 0 01-1.862-.732l5.5-14a1 1 0 01.912-.633zm1.618 11.995a1 1 0 00.896-.896l-.896.896z" clipRule="evenodd" /></g><defs></defs></React.Fragment>, },
  'small'
);
